// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spacingNone": "0",
	"spacingA": "4px",
	"spacingB": "8px",
	"spacingC": "12px",
	"spacingD": "16px",
	"spacingE": "24px",
	"spacingF": "32px",
	"spacingG": "40px",
	"spacingH": "56px",
	"spacingI": "64px",
	"spacingJ": "80px",
	"radiusRoundedNone": "0",
	"radiusRoundedA": "4px",
	"radiusRoundedB": "8px",
	"radiusRoundedC": "12px",
	"radiusRoundedD": "16px",
	"radiusRoundedE": "50rem",
	"elevation01": "0px 2px 2px 0px rgba(0,0,0,.03),0px 3px 1px -2px rgba(0,0,0,.07),0px 1px 5px 0px rgba(0,0,0,.06)",
	"elevation02": "0px 4px 6px 0px rgba(0,0,0,.02),0px 2px 12px -2px rgba(0,0,0,.08),0px 3px 6px 0px rgba(0,0,0,.06)",
	"elevation03": "0px 2px 6px 0px rgba(0,0,0,.04),0px 8px 12px -2px rgba(0,0,0,.06),0px 4px 6px 0px rgba(0,0,0,.04)",
	"elevation04": "0px 8px 8px 0px rgba(0,0,0,.04),0px 8px 20px -3px rgba(0,0,0,.1),0px 4px 8px -2px rgba(0,0,0,.06)",
	"elevation05": "0px -4px 6px 0px rgba(0,0,0,.02),0px -2px 12px -2px rgba(0,0,0,.08),0px -3px 6px 0px rgba(0,0,0,.06)",
	"elevationInverse01": "0px 2px 2px 0px rgba(0,0,0,.12),0px 3px 1px -2px rgba(0,0,0,.28),0px 1px 5px 0px rgba(0,0,0,.24)",
	"elevationInverse02": "0px 4px 6px 0px rgba(0,0,0,.08),0px 2px 12px -2px rgba(0,0,0,.32),0px 3px 6px 0px rgba(0,0,0,.24)",
	"elevationInverse03": "0px 2px 6px 0px rgba(0,0,0,.12),0px 8px 12px -2px rgba(0,0,0,.24),0px 4px 6px 0px rgba(0,0,0,.16)",
	"elevationInverse04": "0px 8px 8px 0px rgba(0,0,0,.16),0px 3px 20px -3px rgba(0,0,0,.4),0px 4px 8px -2px rgba(0,0,0,.24)",
	"elevationInverse05": "0px -4px 6px 0px rgba(0,0,0,.08),0px -2px 12px -2px rgba(0,0,0,.32),0px -3px 6px 0px rgba(0,0,0,.24)",
	"elevationInverseCard": "0px 0px 1px 0px rgba(0,0,0,.24),0px 1px 5px 0px rgba(0,0,0,.08),0px 0px 4px 0px rgba(0,0,0,.16)",
	"elevationDark01": "0px 2px 2px 0px rgba(0,0,0,.03),0px 3px 1px -2px rgba(0,0,0,.07),0px 1px 5px 0px rgba(0,0,0,.06)",
	"elevationDark02": "0px 4px 6px 0px rgba(0,0,0,.02),0px 2px 12px -2px rgba(0,0,0,.08),0px 3px 6px 0px rgba(0,0,0,.06)",
	"elevationDark03": "0px 2px 6px 0px rgba(0,0,0,.04),0px 8px 12px -2px rgba(0,0,0,.06),0px 4px 6px 0px rgba(0,0,0,.04)",
	"elevationDark04": "0px 8px 8px 0px rgba(0,0,0,.04),0px 8px 20px -3px rgba(0,0,0,.1),0px 4px 8px -2px rgba(0,0,0,.06)",
	"elevationDark05": "0px -4px 6px 0px rgba(0,0,0,.02),0px -2px 12px -2px rgba(0,0,0,.08),0px -3px 6px 0px rgba(0,0,0,.06)",
	"elevationDarkCard": "0px 0px 1px 0px rgba(0,0,0,.12),0px 1px 5px 0px rgba(0,0,0,.04),0px 0px 4px 0px rgba(0,0,0,.1)",
	"elevationDarkInverse01": "0px 2px 2px 0px rgba(0,0,0,.12),0px 3px 1px -2px rgba(0,0,0,.28),0px 1px 5px 0px rgba(0,0,0,.24)",
	"elevationDarkInverse02": "0px 4px 6px 0px rgba(0,0,0,.08),0px 2px 12px -2px rgba(0,0,0,.32),0px 3px 6px 0px rgba(0,0,0,.24)",
	"elevationDarkInverse03": "0px 2px 6px 0px rgba(0,0,0,.12),0px 8px 12px -2px rgba(0,0,0,.24),0px 4px 6px 0px rgba(0,0,0,.16)",
	"elevationDarkInverse04": "0px 8px 8px 0px rgba(0,0,0,.16),0px 3px 20px -3px rgba(0,0,0,.4),0px 4px 8px -2px rgba(0,0,0,.24)",
	"elevationDarkInverse05": "0px -4px 6px 0px rgba(0,0,0,.08),0px -2px 12px -2px rgba(0,0,0,.32),0px -3px 6px 0px rgba(0,0,0,.24)",
	"elevationCard": "0px 0px 1px 0px rgba(0,0,0,.12),0px 1px 5px 0px rgba(0,0,0,.04),0px 0px 4px 0px rgba(0,0,0,.1)",
	"fontWeightBold": "700",
	"fontWeightExtraBold": "800",
	"fontWeightRegular": "400"
};
export default ___CSS_LOADER_EXPORT___;
